import React from 'react'
import { TICKET_STATUS_OPTIONS } from '../../../utils/static_data'

function HorizontalNavbar({
  data = [
    {
      label: 'All',
      value: '',
    },
    ...TICKET_STATUS_OPTIONS,
  ],
  handleSearch = () => {},
  className='d-flex align-items-center justify-content-between my-1 '
}) {
  const [index, setIndex] = React.useState(0)
  const onClick = (i, item) => {
    setIndex(i)
    handleSearch({
      ticket_status: item.value,
    })
  }
  return (
    <div className='overflow-auto tab-scrollbar-hidden' style={{borderBottom: '1px solid #E0E0E0' }}>
    <div
      style={{ color: '#676767',}}
      className={className}
    >
      {data.map((item, i) => (
        <div
          onClick={() => onClick(i, item)}
          style={{
            color: i === index ? '#288BCF' : '#676767',
            borderBottom: i === index ? '4px solid #288BCF' : 0,
            marginBottom: i === index ? -3 : 0,
            cursor: 'pointer',
          }}
          className='p-2 mx-2 text-center text-nowrap'
        >
          {item.label}
        </div>
      ))}
    </div>
    </div>
  )
}

export default HorizontalNavbar
